import AddFlashcardOption from "../../Flashcards/App/Options/Views/AddFlashcardOption";

function AddFlashcardFilter(props) {
	const onClick = async (flashcard) => {
		if (props.flashcard) {
			return props.setSelectedData({
				flashcards: props.selectedData.flashcards.map((fc) => {
					if (fc.key === props.flashcard.key) {
						return {
							...fc,
							...flashcard,
						};
					}

					return fc;
				}),
			});
		}

		return props.setSelectedData({
			flashcards: [...props.selectedData.flashcards, flashcard].map(
				(fc, key) => ({ ...fc, key }),
			),
		});
	};

	return (
		<AddFlashcardOption
			onAdd={onClick}
			flashcard={props.flashcard}
			onClose={props.onClose}
		/>
	);
}

export default AddFlashcardFilter;
